// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"4b3931cf","211":"0a220032","420":"5d1c6401","461":"4da540e3","525":"9f0d4a3e","855":"65c02b1a","934":"a71ee82e"}[chunkId] + ".chunk.css";
};